import React, { createContext, useState, useContext, useEffect } from 'react';

// Default settings
const defaultSettings = {
  // Speech recognition settings
  speechRecognitionEnabled: true,
  useGoogleSpeechApi: false,
  autoSendSpeech: false,

  // Audio playback settings
  autoPlayAudio: false,
  autoPlayRecordings: true,

  // Whisper settings
  useWhisperApi: true,
  autoTranscribeRecordings: true,

  // TTS Voice settings (NEW)
  ttsVoiceGender: 'Female',
  ttsVoiceQualityLearning: 'low',      // Default for learning sessions
  ttsVoiceQualityBreadcrumbs: 'medium' // Default for breadcrumbs stories
};

// Create the context
const SettingsContext = createContext();

// Provider component
export const SettingsProvider = ({ children }) => {
  // Initialize state from localStorage or defaults
  const [settings, setSettings] = useState(() => {
    const savedSettings = localStorage.getItem('language-app-settings');
    if (savedSettings) {
      // Merge saved settings with defaults to ensure new settings are included
      const parsed = JSON.parse(savedSettings);
      return { ...defaultSettings, ...parsed };
    }
    return defaultSettings;
  });

  // Update localStorage when settings change
  useEffect(() => {
    localStorage.setItem('language-app-settings', JSON.stringify(settings));
  }, [settings]);

  // Update a single setting
  const updateSetting = (key, value) => {
    setSettings(prev => ({
      ...prev,
      [key]: value
    }));
  };

  // Toggle a boolean setting
  const toggleSetting = (key) => {
    setSettings(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  // Reset all settings to defaults
  const resetSettings = () => {
    setSettings(defaultSettings);
  };

  return (
    <SettingsContext.Provider value={{
      ...settings,
      updateSetting,
      toggleSetting,
      resetSettings
    }}>
      {children}
    </SettingsContext.Provider>
  );
};

// Custom hook to use the settings context
export const useSettings = () => useContext(SettingsContext);

export default SettingsContext;